import { _ as _objectSpread2 } from './_rollupPluginBabelHelpers-fb970440.js';
import { makeVar } from '@apollo/client';

var init_state = {
  checkAuth: {
    userId: "",
    lastLogin: "",
    mfaAccess: "",
    role: {
      roleName: "",
      roleCode: ""
    }
  },
  userRoles: [],
  userMyDetail: {
    userType: {
      typeName: ""
    },
    userCategory: {
      categoryName: ""
    },
    status: "",
    profile: {
      userImage: "",
      firstName: "",
      middleName: "",
      lastName: "",
      mobileNumber: "",
      emailId: "",
      panCardNumber: "",
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      cityTownVillage: "",
      pinCode: "",
      district: "",
      state: ""
    },
    organisation: {
      intermediaries: [],
      associatedCoreEntity: {
        type: "",
        value: ""
      }
    }
  }
};
var profileDataVar = makeVar(init_state);
var initProfileDataState = function initProfileDataState() {
  profileDataVar(init_state);
};
var updateProfileData = function updateProfileData(data) {
  profileDataVar(_objectSpread2(_objectSpread2({}, profileDataVar()), data));
};
var updateDefaultImdDetails = function updateDefaultImdDetails(imdCode) {
  var _profileDataVar, _profileDataVar$userM, _profileDataVar$userM2, _profileDataVar2, _profileDataVar2$user, _profileDataVar2$user2, _profileDataVar2$user3;

  profileDataVar(_objectSpread2(_objectSpread2({}, profileDataVar()), {}, {
    organisation: {
      associatedCoreEntity: (_profileDataVar = profileDataVar()) === null || _profileDataVar === void 0 ? void 0 : (_profileDataVar$userM = _profileDataVar.userMyDetail) === null || _profileDataVar$userM === void 0 ? void 0 : (_profileDataVar$userM2 = _profileDataVar$userM.organisation) === null || _profileDataVar$userM2 === void 0 ? void 0 : _profileDataVar$userM2.associatedCoreEntity,
      intermediaries: (_profileDataVar2 = profileDataVar()) === null || _profileDataVar2 === void 0 ? void 0 : (_profileDataVar2$user = _profileDataVar2.userMyDetail) === null || _profileDataVar2$user === void 0 ? void 0 : (_profileDataVar2$user2 = _profileDataVar2$user.organisation) === null || _profileDataVar2$user2 === void 0 ? void 0 : (_profileDataVar2$user3 = _profileDataVar2$user2.intermediaries) === null || _profileDataVar2$user3 === void 0 ? void 0 : _profileDataVar2$user3.map(function (dat) {
        if ((dat === null || dat === void 0 ? void 0 : dat.intermediaryCode) === imdCode) {
          return _objectSpread2(_objectSpread2({}, dat), {}, {
            isSelected: true
          });
        } else {
          return _objectSpread2(_objectSpread2({}, dat), {}, {
            isSelected: false
          });
        }
      })
    }
  }));
};

function ShortenString(data, allowedLength) {
  return data ? data.length > allowedLength ? "".concat(data.substring(0, allowedLength - 1), "...") : data : data;
}

export { ShortenString as S, updateDefaultImdDetails as a, initProfileDataState as i, profileDataVar as p, updateProfileData as u };
